"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateNowInBookingTime = calculateNowInBookingTime;
const constants_1 = require("@daytrip/constants");
const utils_1 = require("@daytrip/utils");
function calculateNowInBookingTime(originTimeZone) {
    const now = new Date();
    const nowUTC = new Date(now.getTime() - now.getTimezoneOffset() * constants_1.MINUTE_IN_MILLISECONDS);
    const nowShifted = (0, utils_1.transformUTCtoZonedTime)(nowUTC, originTimeZone);
    return nowShifted.getTime();
}
//# sourceMappingURL=calculateNowInBookingTime.js.map